import React from 'react';
import { BlogCard } from './BlogCard';

export const BlogList = ({ posts }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '2rem'
    }}
    data-testid="blog-list"
  >
    {posts.map((post) => (
      <BlogCard key={post.id} post={post} />
    ))}
  </div>
);
